module.exports = __webpack_public_path__ + "img/email.6b02fc8e.svg";